var _classCallCheck = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

/**
 * Local dependencies
 */
var _require = require('../errors'),
    NotSupportedError = _require.NotSupportedError;
/**
 * KeyAlgorithm dictionary
 */


var KeyAlgorithm =
/**
 * constructor
 *
 * @param {object} algorithm
 */
function KeyAlgorithm(algorithm) {
  "use strict";

  _classCallCheck(this, KeyAlgorithm);

  Object.assign(this, algorithm); // validate name

  if (this.name === undefined) {
    throw new Error('KeyAlgorithm must have a name');
  }
};
/**
 * Export
 */


module.exports = KeyAlgorithm;